<!-- @format -->

<link-outer onclick="{ onClick }">
  <slot></slot>
  <script>
    export default {
      onClick(e) {
        e.preventDefault();
        window.open(this.root.href, this.root.href, "noreferrer");
      },
    };
  </script>
</link-outer>
